import { useMutation, useQueryClient } from "@tanstack/react-query";

import { BannerData, ENDPOINTS, QUERY_KEYS, useApi } from "shared";

const useBannerUpdate = (onSuccessCallback: (response: any) => void) => {
    const queryClient = useQueryClient();
    const { updateData, handleResponse } = useApi();

    return useMutation({
        mutationFn: (payload: BannerData) => {
            const { id, isActive, level, message } = payload;

            return updateData(ENDPOINTS.Banners, id, {
                is_active: isActive,
                level: level,
                message: message
            });
        },
        onSuccess: response => {
            queryClient.invalidateQueries({ queryKey: QUERY_KEYS.banners.all });

            onSuccessCallback(response);
        },
        onError: error => handleResponse(error)
    });
};

export { useBannerUpdate };
